<template>
  <div class="navBar" :style="{ background: background }">
    <div class="fanhuiBox" @click="fanhui()">
      <img class="fanhui" src="../assets/icons/fanhui.png" alt="" />
    </div>
    <div class="title">
      <p :style="{ color: colorStyle }">{{ title }}</p>
    </div>
  </div>
</template>
  
  <script>
export default {
  name: "NavBar",
  props: {
    title: {
      default: "",
      type: String,
    },
    colorStyle: {
      default: "#222",
      type: String,
    },
    background: {
      default: "",
      type: String,
    },
  },
  data() {
    return {};
  },

  mounted() {},

  methods: {
    fanhui() {
      this.$router.go(-1);
    },
  },
};
</script>
  
  <style lang="less" scoped>
.navBar {
  position: relative;
  height: 50px;
  .fanhuiBox {
    height: 100%;
    width: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    .fanhui {
      width: 17px;
      height: 17px;
    }
  }
  .title {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    font-weight: 600;
    font-size: 17px;
  }
}
</style>